var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLoading = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "loading")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "earn_farms_enable2",
    transform: "translate(-597.000000, -347.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(69.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(376.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(152.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C11.2450025,24 10.6329114,23.3879089 10.6329114,22.6329114 C10.6329114,21.8779139 11.2450025,21.2658228 12,21.2658228 C17.1173468,21.2658228 21.2658228,17.1173468 21.2658228,12 C21.2658228,6.88265316 17.1173468,2.73417722 12,2.73417722 C6.88265316,2.73417722 2.73417722,6.88265316 2.73417722,12 C2.73417722,12.7549975 2.12208608,13.3670886 1.36708861,13.3670886 C0.612091139,13.3670886 -6.27958787e-16,12.7549975 -6.27958787e-16,12 C-6.27958787e-16,5.37259747 5.37259747,-6.27958787e-16 12,-6.27958787e-16 C18.6274025,-6.27958787e-16 24,5.37259747 24,12 C24,18.6274025 18.6274025,24 12,24 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading.f15f3e5b.svg";
export { ForwardRef as ReactComponent };